'use strict';

import Navigo from './navigo.js'

const router = new Navigo(window.location.origin)

export { router }
